<template>
  <section aria-labelledby="contact-page-heading">
    <div class="container mt-4 fullPage">
      <div class="row">
        <h1 id="contact-page-heading" class="display-1 text-center">
          <span class="heading_bdr_btm">Contact Us</span>
        </h1>
      </div>
      <div class="row">

        <!-- <div class="col-md-5 col-sm-10 col-sm-offset-1  col-xs-12">
          <h2 class="mt-4 contact-form-title">
            Let us contact you by filling the simple form
          </h2>

          <form
            v-on:submit.prevent="onSubmit"
            class="mt-3"
            aria-label="Contact form"
            novalidate
          >
            <p class="required-note"><span aria-hidden="true">*</span> indicates a required field</p>
            <v-text-field
              ref="nameField"
              v-model="name"
              :error-messages="nameErrors"
              color="black"
              label="Name *"
              required
              autocomplete="name"
              :aria-required="true"
              :aria-invalid="nameErrors.length > 0"
              @input="$v.name.$touch()"
              @blur="$v.name.$touch()"
            ></v-text-field>
            <v-text-field
              ref="emailField"
              v-model="email"
              :error-messages="emailErrors"
              color="black"
              label="E-mail *"
              type="email"
              required
              autocomplete="email"
              :aria-required="true"
              :aria-invalid="emailErrors.length > 0"
              @input="$v.email.$touch()"
              @blur="$v.email.$touch()"
            ></v-text-field>
            <v-text-field
              ref="mobileField"
              v-model="mobile"
              :error-messages="mobileErrors"
              color="black"
              :counter="10"
              label="Mobile *"
              type="tel"
              required
              autocomplete="tel"
              inputmode="numeric"
              hint="Enter a 10-digit mobile number"
              persistent-hint
              :aria-required="true"
              :aria-invalid="mobileErrors.length > 0"
              @input="$v.mobile.$touch()"
              @blur="$v.mobile.$touch()"
            ></v-text-field>
            <v-select
              ref="levelField"
              v-model="level"
              :items="queryLevels"
              :error-messages="selectErrors"
              color="black"
              label="What are you looking for? *"
              required
              :aria-required="true"
              :aria-invalid="selectErrors.length > 0"
              :menu-props="{ offsetY: true, closeOnContentClick: true }"
              @change="$v.level.$touch()"
              @blur="$v.level.$touch()"
            ></v-select>
            <v-text-field
              v-if="level ==='Other'"
              ref="otherQueryField"
              v-model="otherQuery"
              color="black"
              label="Enter your other query"
            ></v-text-field>
            <div
              role="status"
              aria-live="polite"
              aria-atomic="true"
              class="sr-only"
            >{{ liveFieldError }}</div>
            <div
              role="alert"
              aria-live="assertive"
              aria-atomic="true"
              class="sr-only"
            >{{ submitError }}</div>
            <p
              role="status"
              aria-live="polite"
              class="form-status sr-only"
            >{{ formStatus }}</p>
            <button
              type="submit"
              class="btn btn_custom btn_contact"
            >Submit</button>
          </form>
        </div> -->
        <div class="col-md-5 col-md-pull-0 col-xs-12 col-sm-10 col-sm-offset-1 ">
          <h2 class="mt-4 contact-info-title">Other ways to contact us</h2>
          <div class="row">
            <div class="col-md-9">
              <table class="table contactus_table">
                <caption class="sr-only">Grow With Stocks contact details</caption>
                <tbody>
                <tr>
                  <th scope="row" class="subheading">Address</th>
                  <td>120, Shastri Nagar, Jammu - 180004</td>
                </tr>
                <tr>
                  <th scope="row" class="subheading">Telephone</th>
                  <td><a href="tel:+919271212131">+91 - 9271212131</a></td>
                </tr>
                <tr>
                  <th scope="row" class="subheading">E-mail</th>
                  <td><a href="mailto:info@growwithstocks.com">info@growwithstocks.com</a></td>
                </tr>
                <tr>
                  <th scope="row" class="subheading">Office Hours</th>
                  <td>10 am - 6 pm (Monday - Friday)</td>
                </tr>
                <tr>
                  <th scope="row" class="subheading">Social Media</th>
                  <td>
                    <ul id="contactus_social" aria-label="Social media links">
                      <li>
                        <a
                          href="https://www.facebook.com/growwithstocks/"
                          class="h2"
                          target="_blank"
                          rel="noopener"
                          aria-label="Grow With Stocks on Facebook (opens in new tab)"
                        >
                          <i class="icon fab fa-facebook" aria-hidden="true"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.instagram.com/growwithstocks/"
                          class="h2"
                          target="_blank"
                          rel="noopener"
                          aria-label="Grow With Stocks on Instagram (opens in new tab)"
                        >
                          <i class="icon ml-2 fab fa-instagram" aria-hidden="true"></i>
                        </a>
                      </li>
                    </ul>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { validationMixin } from "vuelidate";
  import { required, maxLength, email, numeric } from "vuelidate/lib/validators";
  import lb from "../util/lb";

  export default {
    name: "contact",
    mixins: [validationMixin],
    validations: {
      name: { required },
      email: { required, email },
      level: { required },
      mobile: { numeric, required, maxLength: maxLength(10) }
    },
    data() {
      return {
        name: null,
        email: null,
        mobile: null,
        level: null,
        otherQuery: null,
        formStatus: "",
        submitError: "",
        liveFieldError: "",
        queryLevels: [
          "I am a new investor and want to know more.",
          "I am an experienced investor and want to know more",
          "Other"
        ]
      };
    },
    computed: {
      selectErrors() {
        const errors = [];
        if (!this.$v.level.$dirty) return errors;
        !this.$v.level.required && errors.push("Please select the above ");
        return errors;
      },
      mobileErrors() {
        const errors = [];
        if (!this.$v.mobile.$dirty) return errors;
        !this.$v.mobile.required && errors.push("Mobile Number is required.");
        !this.$v.mobile.maxLength && errors.push("Enter correct Mobile Number.");
        return errors;
      },
      nameErrors() {
        const errors = [];
        if (!this.$v.name.$dirty) return errors;
        !this.$v.name.required && errors.push("Name is required.");
        return errors;
      },
      emailErrors() {
        const errors = [];
        if (!this.$v.email.$dirty) return errors;
        !this.$v.email.email && errors.push("Must be valid e-mail");
        !this.$v.email.required && errors.push("E-mail is required");
        return errors;
      },
      formErrors() {
        return [
          ...this.nameErrors,
          ...this.emailErrors,
          ...this.mobileErrors,
          ...this.selectErrors
        ].join(". ");
      }
    },
    watch: {
      nameErrors(newVal, oldVal) {
        if (newVal.length && (!oldVal || !oldVal.length)) this.announceError("Name", newVal[0]);
      },
      emailErrors(newVal, oldVal) {
        if (newVal.length && (!oldVal || !oldVal.length)) this.announceError("Email", newVal[0]);
      },
      mobileErrors(newVal, oldVal) {
        if (newVal.length && (!oldVal || !oldVal.length)) this.announceError("Mobile", newVal[0]);
      },
      selectErrors(newVal, oldVal) {
        if (newVal.length && (!oldVal || !oldVal.length)) this.announceError("What are you looking for", newVal[0]);
      },
      level(newVal) {
        if (newVal === "Other") {
          this.$nextTick(() => {
            const ref = this.$refs.otherQueryField;
            if (ref && typeof ref.focus === "function") ref.focus();
          });
        }
      }
    },
    methods: {
      announceError(label, msg) {
        // NVDA reliably reads live-region changes only when the DOM mutation
        // is split across paint cycles. $nextTick is a single microtask and is
        // sometimes coalesced away, so use a real timeout to guarantee NVDA
        // sees an empty-then-populated transition.
        if (this._announceTimer) clearTimeout(this._announceTimer);
        this.liveFieldError = "";
        this._announceTimer = setTimeout(() => {
          this.liveFieldError = `${label}: ${msg}`;
        }, 100);
      },
      focusFirstInvalidField() {
        const order = [
          { errors: this.nameErrors, ref: "nameField" },
          { errors: this.emailErrors, ref: "emailField" },
          { errors: this.mobileErrors, ref: "mobileField" },
          { errors: this.selectErrors, ref: "levelField" }
        ];
        const target = order.find(f => f.errors.length > 0);
        if (!target) return;
        this.$nextTick(() => {
          const ref = this.$refs[target.ref];
          if (ref && typeof ref.focus === "function") ref.focus();
        });
      },
      async onSubmit() {
        this.$v.$touch();
        this.submitError = "";
        if (!this.$v.$invalid) {
          try {
            const response = await lb.post("/api/Messages/sendContactUsDetails", {
              contactInfo: {
                name: this.name,
                level: this.level,
                otherQuery: this.otherQuery || "",
                email: this.email,
                mobile: this.mobile
              }
            });
            this.$v.$reset();
            this.name = null;
            this.email = null;
            this.mobile = null;
            this.level = null;
            this.otherQuery = null;
            this.formStatus = "Thanks for your query, we will contact you shortly.";
            this.$toasted.show(
              "Thanks for your query, we will contact you shortly.",
              {
                duration: 5000,
                position: "bottom-right"
              }
            );
          } catch (err) {
            console.log(err);
            this.formStatus = "Submission failed. Please try again.";
            this.$toasted.show("Oops some error occurred", {
              duration: 2000,
              position: "bottom-right"
            });
          }
        } else {
          const count = this.nameErrors.length + this.emailErrors.length +
                        this.mobileErrors.length + this.selectErrors.length;
          this.formStatus = "Please correct the errors above and try again.";
          this.submitError = count === 1
            ? "Form has 1 error. Please review the highlighted field and try again."
            : `Form has ${count} errors. Please review the highlighted fields and try again.`;
          this.focusFirstInvalidField();
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .btn_custom {
    background-color: #1a7055 !important;
    color: #fff !important;
    font-weight: 600;
    margin: auto;
    height: 50px;
    width: auto;
    border: 2px solid transparent;
  }
  .btn_custom:hover,
  .btn_custom:focus {
    background-color: #0d3d2e !important;
  }
  .btn_custom:focus-visible {
    outline: 3px solid #ffbf47;
    outline-offset: 2px;
    /* Pair amber with dark halo so focus is visible on dark green button fill. */
    box-shadow:
      0 0 0 2px #0d3d2e,
      0 0 0 7px rgba(13, 61, 46, 0.55),
      0 8px 18px rgba(13, 61, 46, 0.28);
  }
  .fullPage {
    min-height: 100vh;
  }
  td, th {
    padding: 13px;
  }
  th[scope="row"] {
    text-align: left;
    font-weight: 700;
  }
  ul {
    list-style: none;
  }
  li {
    display: inline;
  }
  #contactus_social {
    padding: 0;
  }
  /* WCAG 2.5.5/2.5.8 — touch target ≥ 44×44 for social icons */
  #contactus_social a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 44px;
    min-height: 44px;
    padding: 6px;
    margin-right: 6px;
  }
  .contact-form-title,
  .contact-info-title {
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 18px;
  }
  /* WCAG 2.4.7 — Vuetify already paints its own focus state on the v-select
     input slot. Suppress the global *:focus-visible outline on the wrapper
     elements so only the inner input shows one ring, not two.
     ::v-deep is required: Vuetify's internal slot elements are children of
     the v-select root and don't carry this component's scoped data-v-* attr,
     so a plain descendant selector would not reach them. */
  .v-input.v-select::v-deep {
    .v-input__slot:focus,
    .v-input__slot:focus-visible,
    .v-select__slot:focus,
    .v-select__slot:focus-visible,
    .v-select__selections:focus,
    .v-select__selections:focus-visible {
      outline: none !important;
      box-shadow: none !important;
    }
  }
  .v-input.v-select:focus,
  .v-input.v-select:focus-visible {
    outline: none !important;
    box-shadow: none !important;
  }
  .required-note {
    font-size: 13px;
    color: #595959;
    margin-bottom: 8px;
  }
  .sr-only {
    position: absolute !important;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
  h1.display-1 {
    text-align: center;
    margin-bottom: 50px;
  }
  /*==========  Mobile First Method  ==========*/

  /* Custom, iPhone Retina */
  @media only screen and (min-width: 320px) {
  }

  /* Extra Small Devices, Phones */
  @media only screen and (min-width: 480px) {
  }

  /* Small Devices, Tablets */
  @media only screen and (min-width: 768px) {
  }

  /* Medium Devices, Desktops */
  @media only screen and (min-width: 992px) {
  }

  /* Large Devices, Wide Screens */
  @media only screen and (min-width: 1200px) {
  }

  /*==========  Non-Mobile First Method  ==========*/

  /* Large Devices, Wide Screens */
  @media only screen and (max-width: 1200px) {
  }

  /* Medium Devices, Desktops */
  @media only screen and (max-width: 992px) {
  }

  /* Small Devices, Tablets */
  @media only screen and (max-width: 768px) {
  }

  /* Extra Small Devices, Phones */
  @media only screen and (max-width: 480px) {
    .btn_contact {
      display: block;
      margin: auto;
    }
  }

  /* Custom, iPhone Retina */
  @media only screen and (max-width: 320px) {
  }
</style>



// WEBPACK FOOTER //
// src/views/Contact.vue